module.exports = __webpack_public_path__ + "img/img3.97dc51b5.svg";